import { useThemeUI, jsx, ThemeProvider as ThemeProvider$1 } from '@theme-ui/core';
import { css } from '@theme-ui/css';
import { ColorModeProvider } from '@theme-ui/color-modes';
import { MDXProvider } from '@theme-ui/mdx';
import { Global } from '@emotion/react';

var RootStyles = function RootStyles() {
  return jsx(Global, {
    styles: function styles(emotionTheme) {
      var _theme$config;

      var theme = emotionTheme;

      var _ref = theme.config || theme,
          useRootStyles = _ref.useRootStyles;

      if (useRootStyles === false || theme.styles && !theme.styles.root) {
        return null;
      }

      var boxSizing = ((_theme$config = theme.config) === null || _theme$config === void 0 ? void 0 : _theme$config.useBorderBox) === false ? undefined : 'border-box';
      return css({
        '*': {
          boxSizing: boxSizing
        },
        html: {
          variant: 'styles.root'
        },
        body: {
          margin: 0
        }
      })(theme);
    }
  });
};

var ThemeProvider = function ThemeProvider(_ref2) {
  var theme = _ref2.theme,
      components = _ref2.components,
      children = _ref2.children;
  var outer = useThemeUI();

  if (typeof outer.setColorMode === 'function') {
    return jsx(ThemeProvider$1, {
      theme: theme
    }, jsx(MDXProvider, {
      components: components,
      children: children
    }));
  }

  return jsx(ThemeProvider$1, {
    theme: theme
  }, jsx(ColorModeProvider, null, jsx(RootStyles), jsx(MDXProvider, {
    components: components,
    children: children
  })));
};

export { ThemeProvider };